module.exports = __webpack_public_path__ + "static/media/roger-keller.02e953fc.jpg";